export default __webpack_public_path__ + "media/images/icon_blocks-bbacb5b2faa1fabb2cef915a55d20e96.png";